import { gql } from 'graphql-request'

class PlaceQueries {
  getAll = gql`
    query getPlaces($where: PlaceQueryWhereInput, $first: Int, $skip: Int, $orderBy: PlaceExtendedOrderByInput) {
      places(where: $where, first: $first, skip: $skip, orderBy: $orderBy) {
        id
        name
        googlePlaceId
        address
        nbExperiences
        averageEvaluation
        claimStatus
        averageEvaluation
        categories {
          id
          name
        }
        customer {
          id
          name
        }
        requestedClaimBy {
          id
          name
        }
        location {
          id
          city
        }
      }
    }
  `

  getAllWithAnalytics = gql`
    query getPlaces($where: PlaceQueryWhereInput, $first: Int, $skip: Int, $orderBy: PlaceExtendedOrderByInput) {
      places(where: $where, first: $first, skip: $skip, orderBy: $orderBy) {
        id
        name
        nbExperiences
        customer {
          id
          name
        }
        analytics {
          views
          actions
          nbExperiences
          nbPositiveExperiences
          nbNeutralExperiences
          nbNegativeExperiences
          distinctExperiencesPercentage
        }
      }
    }
  `

  getPlaceCategories = `
   query getPlaceCategories($where: PlaceCategoryWhereInput) {
    placeCategories(where: $where) {
      id
      name
    }
   }
  `

  getPlaceById = `
   query getPlaceById($where: PlaceExtendedWhereUniqueInput!) {
    place(where: $where) {
        id
        name
        googlePlaceId
        address
        nbExperiences
        averageEvaluation
        claimStatus
        averageEvaluation
        description
        actionText
        actionUrl
        categories {
          id
          name
        }
        customer {
          id
          name
        }
        requestedClaimBy {
          id
          name
        }
        location {
          id
          city
        }
        heroImage {
          id
          url
          reference
        }       
        locationValidationQrCode {
          id
          url
        }
        configFlags {
          isGeolocationCheckEnabled
        }
    }
   }
  `

  countAll = gql`
    query countAll($where: PlaceQueryWhereInput) {
      placesConnection(where: $where) {
        aggregate {
          count
        }
      }
    }
  `
}

const placeQueries = new PlaceQueries()

export default placeQueries
